<div class="container-fluid">
  <div class="row mb-4">
    <div class="col-12">
      <div class="d-flex justify-content-between align-items-center">
        <h2 class="mb-0">Features</h2>
        <a [routerLink]="['/','admin','features','new']" class="btn btn-primary">
          <i class="fa fa-plus me-2"></i>Add New Feature
        </a>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="list-group">
        <div class="list-group-item d-flex justify-content-between align-items-center" *ngFor="let feature of features">
          <a [routerLink]="['/','admin','features',feature.id]" class="text-primary text-decoration-none">
            <h5 class="mb-0">{{ feature.displayName }}</h5>
          </a>
          <button class="btn btn-danger btn-sm" (click)="deleteFeature(feature.id)">
            <i class="fa fa-trash me-2"></i>Delete
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
